import Icon from '../components/Icon.vue'

Icon.register({
  'hourglass-half': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M360 0c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24 0 91-51 167.7-120.8 192 69.8 24.3 120.8 101 120.8 192 13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24 0-91 51-167.7 120.8-192-69.8-24.3-120.8-101-120.8-192-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h336zM284.9 384c-17.1-46.8-52.1-80-92.9-80-40.8 0-75.9 33.2-92.9 80h185.8zM284.9 128c7.1-19.4 11.1-41.2 11.1-64h-208c0 22.7 4 44.5 11.1 64h185.9z'
      }
    ]
  }
})
